import { DashboardInfoAPIModel } from 'src/models/api.model'

export interface DashboardState {
  dashboardInfo: DashboardInfoAPIModel
}

export const initialDashboardState: DashboardState = {
  dashboardInfo: undefined
}
